import { render, staticRenderFns } from "./PostEditorForm.vue?vue&type=template&id=738ed2b7&"
import script from "./PostEditorForm.vue?vue&type=script&lang=js&"
export * from "./PostEditorForm.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports